import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  getDocument,
  GlobalWorkerOptions,
  version as pdfjsVersion,
} from 'pdfjs-dist/legacy/build/pdf';
import { useEffect, useState } from 'react';

// Aponta o worker do PDF.js via CDN
GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsVersion}/pdf.worker.min.js`;

export default function PdfPreview({ urlFile, isAndroid }) {
  const theme = useTheme();

  const fileName = urlFile.split('/').pop();
  const [thumb, setThumb] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const pdf = await getDocument(urlFile).promise;
        const page = await pdf.getPage(1);
        const viewport = page.getViewport({ scale: 1 });
        const scale = 100 / viewport.width;
        const scaled = page.getViewport({ scale });
        const canvas = document.createElement('canvas');
        canvas.width = scaled.width;
        canvas.height = scaled.height;
        const ctx = canvas.getContext('2d');
        await page.render({ canvasContext: ctx, viewport: scaled }).promise;
        if (!cancelled) {
          setThumb(canvas.toDataURL());
        }
      } catch (err) {
        console.error('Erro ao gerar thumbnail do PDF', err);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [urlFile]);

  const handleClick = () => {
    if (isAndroid) {
      window.Android.openPDF(urlFile);
    } else {
      window.open(urlFile, '_blank', 'noopener');
    }
  };

  // Evita ternário aninhado: escolhe o ícone de preview
  let previewIcon;
  if (loading) {
    previewIcon = <CircularProgress size={48} sx={{ mr: 1 }} />;
  } else if (thumb) {
    previewIcon = (
      <Box
        component="img"
        src={thumb}
        alt="preview"
        sx={{ width: 48, height: 'auto', mr: 1, borderRadius: 0.5 }}
      />
    );
  } else {
    previewIcon = (
      <PictureAsPdfIcon sx={{ fontSize: 48, mr: 1, color: 'error.main' }} />
    );
  }

  return (
    <Box
      onClick={handleClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        border: 1,
        p: 1,
        borderColor: 'grey.300',
        borderRadius: 1,
        cursor: 'pointer',
        width: 200,
        backgroundColor: theme.palette.background.default,
        '&:hover': { backgroundColor: 'grey.100' },
      }}
    >
      {previewIcon}
      <Typography variant="body2" mt={1} noWrap>
        {fileName}
      </Typography>
    </Box>
  );
}
